'use strict';

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    Loading = require('components/Commons/Loading/Loading'),
    AdminScaffoldingTablePaged = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTablePaged'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    FormGroupTextFieldSuggested = require('components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested'),
    Authentication = require('services/Security').Authentication,
    ContentUtils = require('utils/ContentUtils'),
    InventoryStore = require('stores/InventoryStore'),
    Notification = require('components/Notification/Notification'),
    NavigationUtils = require('utils/NavigationUtils'),
    {orderBy, map, filter} = require('lodash/collection'),
    Constants = require('constants/AppConstants'),
    get = require('lodash/object').get,
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    {Navigation} = require('react-router'),
    ga = require('react-ga');

const pageUrl = '/items/page/';

let ItemsAdmin = React.createClass({displayName: "ItemsAdmin",
    mixins: [Authentication, AdminScaffoldingContextHolder,Navigation],

    getInitialState() {
        return {
            selectedItem: null,
            isEditMode: false,
            isFetching: true,
            filter: {
                code: '',
                description: '',
                category: '',
                subCategory: '',
                unit: ''
            }
        };
    },

    componentDidMount() {
        this.fetchItems();
        ga.pageview('/items-admin');
    },

    fetchItems() {
        const self = this;
        const currentPage = NavigationUtils.getPathParam('page');
        InventoryStore.fetchItems(currentPage, function (items) {
            InventoryStore.fetchLocation(function (locations) {
                const itemsSorted = ContentUtils.filterEnable(ContentUtils.sortList(items, 'description'));
                const locationSorted = ContentUtils.filterEnable(ContentUtils.sortList(locations, 'name'));
                self.setState({
                    items: self.filterVirtualSaleItems(itemsSorted),
                    locations: ContentUtils.filterEnable(locationSorted),
                    isFetching: false
                });
            });
        });
    },

    fetchItemsBy(filter) {
        const self = this;
        InventoryStore.fetchItemsBy(filter, function (items) {
            InventoryStore.fetchLocation(function (locations) {
                const itemsSorted = ContentUtils.sortList(ContentUtils.filterEnable(items), 'description');
                const locationSorted = ContentUtils.sortList(ContentUtils.filterEnable(locations), 'name');
                self.setState({
                    items: self.filterVirtualSaleItems(itemsSorted),
                    locations: ContentUtils.filterEnable(locationSorted),
                    isFetching: false
                });
            });
        });
    },

    _onClickPage(page) {
        this.transitionTo('/items/page/:page', {page});
        this.fetchItems();
    },

    filterVirtualSaleItems(items) {
        return filter(items, item => get(item, 'category') !== Constants.SALE_VIRTUAL_ITEM_CATEGORY);
    },

    onDeleteItem(item, onSuccess, onFailure) {
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('item_admin_delete_warning'),
            () => {
                InventoryStore.deleteItem(item, onSuccess, onFailure);
            }
        );
    },

    onChangeItem(item, onSuccess, onFailure) {
        InventoryStore.changeItem(item, onSuccess, onFailure);
        this.setState(Object.assign(this.getInitialState(), {selectedItem: item}));
    },

    onAddItem(item, onSuccess, onFailure) {
        InventoryStore.addItem(item, onSuccess, onFailure);
    },

    onDuplicate(contextHolder) {
        // get value from all fiels
        let currentSelectedItem = contextHolder.getItem();

        // override with duplicate label
        currentSelectedItem.description = ContentUtils.formatDuplicateName(currentSelectedItem.description);

        // remove id in order to generate a new one like new item
        currentSelectedItem.id = null;

        this.onAddItem(currentSelectedItem, () => {
            Notification.show(t('item_admin_item_duplicated_success'), 'success');
            this.fetchItems();
        });
    },

    shouldNotAllowRepeatName(items, newItemName) {
        let itemNames = map(items, item => get(item, 'description')) || [];
        const currentItemDescription = get(this.state, 'selectedItem.description');

        if (currentItemDescription) {
            itemNames = filter(itemNames, itemName => itemName != currentItemDescription);
        }

        const alreadyExist = itemNames.indexOf(newItemName) > -1;

        return alreadyExist ? t('item_admin_item_already_exist') : '';
    },

    _onTypingFilter(name, match) {
        if (!this.state.isFetching) {
            this.setState(prevState => {
                let nextFilter = prevState.filter || {};
                nextFilter[name] = match;
                this.fetchItemsBy(nextFilter);
                return {
                    filter: nextFilter,
                    isFetching: true
                };
            });
        }
    },

    _onCancel() {
        this.transitionTo(getCurrentUrl());
        this.setState({
            selectedItem: null,
            isEditMode: false,
            filter: {
                code: '',
                description: '',
                category: '',
                subCategory: '',
                unit: '',
                salePrice: ''
            }
        });
    },

    _printReport() {
        InventoryStore.downloadReportXLS(this.state.filter, 'items');
    },

    _onChangeDropDownItem(selectedItem) {
        this.setState({
            selectProductItemDropDown: selectedItem
        });
    },


    _onChangeDropDownLocation(selectedItem) {
        this.setState({
            selectProductItemDropDown: selectedItem
        });
    },


    render() {
        if (!this.state.items) {
            return React.createElement(Loading, null);
        } else {
            const CATEGORIES_TEXTS = Constants.getCategoryMapping(t);
            const CATEGORIES = Constants.ITEM_CATEGORY.map(category => ({category: category, displayText: CATEGORIES_TEXTS[category]}));
            const messages = {
                changeSuccessMessage: t('item_admin_change_success'),
                changeFailureMessage: t('item_admin_change_failure'),
                deleteSuccessMessage: t('item_admin_delete_success'),
                addSuccessMessage: t('item_admin_add_success'),
                addFailureMessage: t('item_admin_add_failure')
            };
            const contextHolder = this.getContextHolderInstance();
            const additionalButtons = [
                {
                    type: 'CHANGE',
                    permission: 'DUPLICATE',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('button_duplicate'), 
                            icon: "content_copy", 
                            type: "icon", 
                            onClick: this.onDuplicate.bind(this, contextHolder)}
                        )
                    )
                }
                ];
            
            let {selectedItem, items, isEditMode, locations, isFetching} = this.state;
            
            const currentSelectedCategory = selectedItem && selectedItem.category
              ? CATEGORIES_TEXTS[selectedItem.category]
              : '';
            
            const currentSelectedCategoryValue = currentSelectedCategory
              ? Object.assign({}, selectedItem, {displayText: currentSelectedCategory})
              : selectedItem;
            
            let secuancialOrder = ContentUtils.filterEnable(orderBy(items, 'description'));
            
            if (secuancialOrder && secuancialOrder.length) {
                secuancialOrder = secuancialOrder.map(item => {
                    item.displayCategory = CATEGORIES_TEXTS[item.category];
                    return item;
                });
            }
            
            let formFieldsEl = [
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "description", 
                    isRelaxedText: true, 
                    name: t('item_admin_description_label'), 
                    value: selectedItem, 
                    label: t('item_admin_description_label'), 
                    isEditMode: isEditMode, 
                    additionalValidation: this.shouldNotAllowRepeatName.bind(this, secuancialOrder), 
                    onEnter: this.__onEnterPress}
                ),

                React.createElement(FormGroupTextFieldSuggested, {
                    operationsHolder: contextHolder, 
                    items: CATEGORIES, 
                    readerAttribute: "displayText", 
                    readerAttributeValue: "category", 
                    writerAttribute: "category", 
                    name: t('item_admin_category'), 
                    label: t('item_admin_category'), 
                    isImmutable: true, 
                    value: currentSelectedCategoryValue, 
                    onChange: this._onChangeDropDownItem, 
                    onEnter: this.__onEnterPress}
                ),

                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "subCategory", 
                    isRelaxedText: true, 
                    isRequired: false, 
                    name: t('item_admin_subcategory'), 
                    value: selectedItem, 
                    label: t('item_admin_subcategory'), 
                    isEditMode: isEditMode, 
                    onEnter: this.__onEnterPress}
                ),

                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "unit", 
                    isRelaxedText: true, 
                    name: t('item_admin_unit'), 
                    value: selectedItem, 
                    label: t('item_admin_unit'), 
                    isEditMode: isEditMode, 
                    onEnter: this.__onEnterPress}
                ),

                React.createElement(FormGroupTextFieldSuggested, {
                    operationsHolder: contextHolder, 
                    items: locations, 
                    readerAttribute: "name", 
                    writerAttribute: "preferredLocationId", 
                    readerAttributeValue: "id", 
                    label: t('item_admin_preferred_location'), 
                    name: t('item_admin_preferred_location'), 
                    isImmutable: true, 
                    value: get(selectedItem, 'preferredLocation'), 
                    onChange: this._onChangeDropDownLocation, 
                    onEnter: this.__onEnterPress}
                )
            ];

            const totalItems = get(secuancialOrder, '0.totalSize') || 0;
            const self = this;
            return (
                React.createElement("div", {className: "brewhouse-view"}, 
                    React.createElement(AdminScaffolding, {
                        title: t('item_admin_title'), 
                        moduleName: "ADMIN_ITEM", 
                        messages: messages, 
                        contextHolder: contextHolder, 
                        value: selectedItem, 
                        fetchItems: () =>  {
                            return (self.fetchItems() || []).map(item => {
                               item.displayCategory = CATEGORIES_TEXTS[item.category];
                               return item;
                            });
                        }, 
                        headerFields: formFieldsEl, 
                        onAdd: this.onAddItem, 
                        onChange: this.onChangeItem, 
                        onCancel: this._onCancel, 
                        onDelete: this.onDeleteItem, 
                        additionalButtons: additionalButtons, 
                        addEnterKeyDown: this.__addEnterKeyDown
                    }, 

                        React.createElement(AdminScaffoldingTablePaged, {
                            headerActiveFilters: this.state.headerActiveFilters, 
                            onRowSelection: this.__onRowSelection, 
                            value: selectedItem, 
                            sortByColumn: ['description'], 
                            filteredColumns: [
                                'code',
                                'description',
                                'category',
                                'subCategory',
                                'unit'
                            ], 
                            displayAttributes: [
                                'code',
                                'description',
                                'displayCategory',
                                'subCategory',
                                'unit',
                                'preferredLocation.name',
                            ], 
                            columnNames: [
                                t('item_admin_column_code'),
                                t('item_admin_column_item_description'),
                                t('item_admin_column_category'),
                                t('item_admin_column_sub_category'),
                                t('item_admin_column_unit'),
                                t('item_admin_column_preferred_location')
                            ], 
                            isLoading: isFetching, 
                            maxPage: ContentUtils.getAmountPageNeeded(totalItems, Constants.MAX_ITEMS_BY_PAGES_ADMINS), 
                            onClickPage: this._onClickPage, 
                            currentPage: NavigationUtils.getPathParam('page'), 
                            columnsFilterValue: this.state.filter, 
                            onCancel:  this._onCancel, 
                            onTypingFilter:  this._onTypingFilter
                        }, 
                            secuancialOrder
                        )
                    )
                )
            );
        }
    }
});

function getCurrentUrl() {
    return pageUrl + NavigationUtils.getPathParam('page');
}
module.exports = ItemsAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/ItemsAdmin/ItemsAdmin.jsx
 **/